var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1603_7352)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.8892,
    cy: 60.8892,
    r: 60.8892,
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.0615,
    y: 20.5518,
    width: 77.6862,
    height: 15.7472,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.0615,
    y: 20.5518,
    width: 77.6862,
    height: 15.7472,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 26,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6264,
    y: 47.3041,
    width: 88.0551,
    height: 26.0976,
    rx: 0.912284,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6264,
    y: 47.3041,
    width: 88.0551,
    height: 26.0976,
    rx: 0.912284,
    fill: "#1AF3DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6264,
    y: 47.3041,
    width: 88.0551,
    height: 26.0976,
    rx: 0.912284,
    stroke: "white",
    strokeWidth: 0.608189
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.8066,
    y: 83,
    width: 77.6862,
    height: 15.7472,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.8066,
    y: 83,
    width: 77.6862,
    height: 15.7472,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 89,
    width: 31,
    height: 6,
    rx: 1.21638,
    fill: "#E0DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9772 55.086V66H46.8229V57.5695L44.2346 58.3924V56.6943L48.7453 55.086H48.9772ZM60.153 61.9306V63.6212H52.306L52.2013 62.3121L56.742 55.1084H58.455L56.5998 58.2128L54.3407 61.9306H60.153ZM58.9188 55.1084V66H56.7644V55.1084H58.9188ZM63.5118 54.51V66H61.3574V54.51H63.5118ZM63.2051 61.6688H62.6141C62.6191 61.1053 62.6939 60.5866 62.8385 60.1129C62.9832 59.6341 63.1901 59.2202 63.4594 58.8711C63.7287 58.517 64.0504 58.2428 64.4244 58.0483C64.8034 57.8538 65.2223 57.7565 65.6811 57.7565C66.0801 57.7565 66.4416 57.8139 66.7658 57.9286C67.0949 58.0383 67.3767 58.2178 67.6111 58.4672C67.8504 58.7115 68.035 59.0332 68.1646 59.4321C68.2943 59.8311 68.3591 60.3148 68.3591 60.8834V66H66.1898V60.8684C66.1898 60.5093 66.1374 60.2276 66.0327 60.0231C65.933 59.8137 65.7858 59.6665 65.5913 59.5818C65.4018 59.492 65.1675 59.4471 64.8882 59.4471C64.579 59.4471 64.3147 59.5045 64.0953 59.6192C63.8808 59.7339 63.7088 59.8934 63.5791 60.0979C63.4494 60.2974 63.3547 60.5318 63.2948 60.8011C63.235 61.0704 63.2051 61.3596 63.2051 61.6688ZM72.1143 59.6192H73.2663C73.6353 59.6192 73.9396 59.5568 74.1789 59.4321C74.4183 59.3025 74.5953 59.123 74.71 58.8936C74.8297 58.6592 74.8896 58.3874 74.8896 58.0782C74.8896 57.7989 74.8347 57.5521 74.725 57.3376C74.6203 57.1182 74.4582 56.9486 74.2388 56.8289C74.0193 56.7043 73.7426 56.6419 73.4084 56.6419C73.1441 56.6419 72.8998 56.6943 72.6754 56.799C72.4509 56.9038 72.2714 57.0509 72.1368 57.2404C72.0021 57.4299 71.9348 57.6593 71.9348 57.9286H69.7729C69.7729 57.3301 69.9325 56.809 70.2517 56.3652C70.5758 55.9213 71.0097 55.5747 71.5533 55.3254C72.0969 55.076 72.6953 54.9513 73.3486 54.9513C74.0867 54.9513 74.7325 55.071 75.286 55.3104C75.8396 55.5448 76.271 55.8914 76.5802 56.3502C76.8893 56.809 77.0439 57.3775 77.0439 58.0557C77.0439 58.3998 76.9642 58.734 76.8046 59.0581C76.645 59.3773 76.4156 59.6665 76.1164 59.9259C75.8221 60.1802 75.4631 60.3847 75.0392 60.5393C74.6153 60.6889 74.139 60.7637 73.6104 60.7637H72.1143V59.6192ZM72.1143 61.2574V60.1428H73.6104C74.2039 60.1428 74.725 60.2101 75.1738 60.3448C75.6227 60.4794 75.9992 60.6739 76.3034 60.9282C76.6076 61.1776 76.837 61.4743 76.9916 61.8184C77.1462 62.1575 77.2235 62.534 77.2235 62.948C77.2235 63.4566 77.1262 63.9105 76.9317 64.3094C76.7372 64.7034 76.463 65.0375 76.1089 65.3118C75.7598 65.5861 75.3509 65.7955 74.8821 65.9402C74.4133 66.0798 73.9021 66.1496 73.3486 66.1496C72.8898 66.1496 72.4385 66.0873 71.9946 65.9626C71.5558 65.8329 71.1568 65.6409 70.7978 65.3866C70.4437 65.1273 70.1594 64.8031 69.945 64.4141C69.7355 64.0202 69.6308 63.5539 69.6308 63.0153H71.7927C71.7927 63.2946 71.8625 63.5439 72.0021 63.7633C72.1417 63.9828 72.3337 64.1548 72.5781 64.2795C72.8275 64.4042 73.1042 64.4665 73.4084 64.4665C73.7525 64.4665 74.0468 64.4042 74.2911 64.2795C74.5405 64.1498 74.73 63.9703 74.8596 63.7409C74.9943 63.5065 75.0616 63.2347 75.0616 62.9255C75.0616 62.5266 74.9893 62.2074 74.8447 61.968C74.7001 61.7237 74.4931 61.5441 74.2238 61.4294C73.9545 61.3147 73.6353 61.2574 73.2663 61.2574H72.1143ZM86.0355 59.5967V61.4818C86.0355 62.2997 85.9482 63.0053 85.7737 63.5988C85.5991 64.1872 85.3473 64.671 85.0181 65.05C84.694 65.424 84.3075 65.7008 83.8587 65.8803C83.4098 66.0598 82.9111 66.1496 82.3626 66.1496C81.9237 66.1496 81.5148 66.0948 81.1358 65.985C80.7568 65.8703 80.4151 65.6933 80.1109 65.4539C79.8117 65.2146 79.5524 64.9128 79.333 64.5488C79.1185 64.1798 78.954 63.7409 78.8393 63.2322C78.7246 62.7236 78.6672 62.1401 78.6672 61.4818V59.5967C78.6672 58.7789 78.7545 58.0782 78.929 57.4947C79.1086 56.9062 79.3604 56.425 79.6846 56.051C80.0137 55.677 80.4027 55.4027 80.8515 55.2281C81.3003 55.0486 81.799 54.9588 82.3476 54.9588C82.7865 54.9588 83.1929 55.0162 83.5669 55.1309C83.9459 55.2406 84.2875 55.4126 84.5917 55.647C84.8959 55.8814 85.1553 56.1831 85.3697 56.5522C85.5841 56.9162 85.7487 57.3526 85.8634 57.8613C85.9781 58.3649 86.0355 58.9434 86.0355 59.5967ZM83.8736 61.7661V59.305C83.8736 58.911 83.8512 58.5669 83.8063 58.2727C83.7664 57.9784 83.7041 57.7291 83.6193 57.5246C83.5345 57.3152 83.4298 57.1456 83.3051 57.016C83.1804 56.8863 83.0383 56.7915 82.8787 56.7317C82.7191 56.6719 82.5421 56.6419 82.3476 56.6419C82.1032 56.6419 81.8863 56.6893 81.6968 56.7841C81.5123 56.8788 81.3552 57.0309 81.2255 57.2404C81.0959 57.4448 80.9961 57.7191 80.9263 58.0632C80.8615 58.4023 80.8291 58.8163 80.8291 59.305V61.7661C80.8291 62.16 80.849 62.5066 80.8889 62.8058C80.9338 63.1051 80.9986 63.3619 81.0834 63.5763C81.1732 63.7858 81.2779 63.9578 81.3976 64.0925C81.5223 64.2221 81.6644 64.3169 81.824 64.3767C81.9885 64.4366 82.1681 64.4665 82.3626 64.4665C82.6019 64.4665 82.8139 64.4191 82.9984 64.3244C83.1879 64.2246 83.3475 64.07 83.4771 63.8606C83.6118 63.6461 83.7115 63.3669 83.7764 63.0228C83.8412 62.6787 83.8736 62.2598 83.8736 61.7661Z",
    fill: "#37474F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1603_7352",
    x: 0,
    y: 0,
    width: 129.778,
    height: 129.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1603_7352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1603_7352",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTime);
export default __webpack_public_path__ + "static/media/modal-time.36d02d57dfccbb681d3d8315a13a8288.svg";
export { ForwardRef as ReactComponent };